import { EventEmitterBase } from '../utils';
import { IVisibilityMonitor } from './models';

export abstract class AbstractVisibilityMonitor extends EventEmitterBase implements IVisibilityMonitor {
    abstract visible?: boolean;

    abstract observe(element: HTMLElement): void;

    abstract start(): void;

    abstract stop(): void;
}
